module.exports = __webpack_public_path__ + "img/JobInterview-1.a08c5e43.svg";